import React from "react";
import { Box, Chip } from "@mui/material";
import Marquee from "react-fast-marquee";

const logos = [
  { img: "E-commerce" },
  { img: "Retail" },
  { img: "Healthcare" },
  { img: "Education" },
  { img: "Finance" },
  { img: "Logistics" },
  { img: "Real Estate" },
  { img: "Travel & Tourism" },
  { img: "Hospitality" },
  { img: "Insurance" },
  { img: "Telecom" },
  { img: "Food & Beverages" },
  { img: "Automotive" },
  { img: "Media & Entertainment" },
  { img: "Nonprofits & NGOs" },
  { img: "Government Services" },
  { img: "Agriculture" },
  { img: "Utilities" },
  { img: "Fashion & Lifestyle" },
  { img: "Manufacturing" },
];

const AutoScrollingChips = () => {
  return (
    <Box
      sx={{
        width: "100%", // Ensure it fits within parent
        overflow: "hidden", // Prevent chips from overflowing
        position: "relative", // Ensure alignment inside the parent
      }}
    >
      <Marquee pauseOnHover={true} speed={50}>
        {logos.map((logo, index) => (
          <Chip
            key={index}
            label={logo.img}
            variant="outlined"
            sx={{
              marginLeft: "12px",
              backgroundColor: "#ABD6EE33",
              border: "#ABD6EE33",
              borderRadius: "8px",
              "&:hover": {
                backgroundColor: "#ABD6EE99",
                borderColor: "#ABD6EE99",
              },
            }}
          />
        ))}
      </Marquee>
    </Box>
  );
};

export default AutoScrollingChips;
